import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';





function MichassMenu() {
	
	const [menuOuvert, setMenuouvert] = useState(false);
	const [curDate, setCurdate] = useState('');

	useEffect(() => {
		const intervalle = setInterval(() => {
			setCurdate(formatDateFranc(new Date()));
		}, 1000);
	}, []);

	const toggleMenu = () => {
		setMenuouvert(!menuOuvert);
	};

	const formatDateFranc = (datetm) => {
		const jour = new Intl.DateTimeFormat('fr-FR', {weekday: 'short'}).format(datetm);
		const dJour = String(datetm.getDate()).padStart(2, '0');
		const mois = new Intl.DateTimeFormat('fr-FR', {month: 'long'}).format(datetm);
		const annee = datetm.getFullYear();
		const dHeure = String(datetm.getHours()).padStart(2, '0');
		const dMin = String(datetm.getMinutes()).padStart(2, '0');
		const dSec = String(datetm.getSeconds()).padStart(2, '0');
		return `${jour.charAt(0).toUpperCase()+jour.slice(1)} ${dJour} ${mois} ${annee} - ${dHeure}:${dMin}:${dSec}`;
	};

	return (
		<nav id="michass-index-navigation">
			<div className="fixed bg-white w-full flex flex-wrap md:text-xs sm:text-xs h-8 items-center justify-between px-4 border-b border-black">
				<span className="flex items-center text-gray-500">
					<svg className="mr-1 w-[20px] h-[20px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
						<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
					</svg>
					{curDate}
				</span>
				<span className="mr-6">0 visite(s)</span>
			</div>
			<div className="max-w-7xl w-100 mx-auto px-2 sm:px-6 lg:px-8 pt-8">
				<div className="relative flex items-center justify-between h-16">
					<div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
						{/* Mobile menu button*/}
						<button
							onClick={toggleMenu}
							className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
							aria-expanded="false"
							>
							<span className="sr-only">Open main menu</span>
							{/* Icon for menu (hamburger icon) */}
							<svg
							className={`${menuOuvert ? 'hidden' : 'block'} h-6 w-6`}
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							aria-hidden="true"
							>
								<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								d="M4 6h16M4 12h16m-7 6h7"
								/>
							</svg>
							{/* Icon for menu close (X icon) */}
							<svg
							className={`${menuOuvert ? 'block' : 'hidden'} h-6 w-6`}
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							aria-hidden="true"
							>
								<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
					<div className="w-full flex flex-wrap items-center justify-center">
						<div className="hidden sm:block sm:ml-6">
							<div className="flex items-center w-100 space-x-8 mt-4">
								<a href="/" className="flex item-center">
									<svg class="w-[40px] h-[36px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
										<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"/>
									</svg>
								</a>
								<a href="/presentation" className="flex flex-wrap items-center hover:text-gray-800">
									Présentation
								</a>
								<a href="/enseignements" className="hover:text-gray-800">
									Enseignements
								</a>
								<a href="/cultes" className="hover:text-gray-800">
									Cultes du dimanche
								</a>
								<a href="/contact" className="hover:text-gray-800">
									Contacts
								</a>
							</div>
						</div>
					</div>
				</div>
				<div className="flex flex-col w-full py-8 justify-center items-center text-white" id="menu-hidden">
					<p className="lg:text-2xl sm:text-md">Mission Internationale Chrétienne d'Aide Spirituelle et Sociale</p>
					<p>Yopougon, Maroc Antenne</p>
					<p>Culte chaque dimanche à 09h30 | <Link to="https://www.facebook.com/profile.php?id=100078003332071">Facebook</Link> | <Link to="https://www.youtube.com/@apotrechristnicolas6675/videos">YouTube</Link> | <Link >Abonnez-vous</Link> </p>
				</div>
			</div>
			{/* Mobile Menu */}
			{
				menuOuvert && (
					<div className="sm:hidden" id="bg-purple">
						<div className="px-2 pt-2 pb-3 space-y-1">
							<a href="/" className="flex  items-center text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium">
								<svg class="w-[40px] h-[36px] text-gray-300 hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
									<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"/>
								</svg>
								Accueil
							</a>
							<a href="/about" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium">
								Présentation
							</a>
							<a href="/enseignements" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium">
								Enseignements
							</a>
							<a href="/cultes" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium">
								Cultes du dimanche
							</a>
							<a href="/contact" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium">
								Contacts
							</a>
						</div>
					</div>
				)
			}
		</nav>
	);
}

export default MichassMenu;
